import { useAuthStore } from "../store/auth.store";
import { useEffect, useState } from "react";
import { useInvoicesStore } from "../store/invoices.store";
import { useInvoices } from "../hook/partner/invoices.partner.hook";
import { PartnerApi } from "../api/partner.api";
import { Pagination } from "../components/List/Pagination";
import { usePopper } from "react-popper";
import { useInvoicesTableStore } from "../store/invoicesTable.store";
import { useBreadcrumbsStore } from "../store/breadcrumbs.store";
import InvoiceTable from "../components/Invoice/InvoiceTable";
import { RowSelector } from "../components/List/RowSelector";
import { FulltextFilter } from "../components/List/FulltextFilter";
import { InvoiceFilter } from "../components/Invoice/InvoiceFilter";
import AnchorData from "../utils/AnchorData";
import { InvoiceFilterActual } from "../components/Invoice/InvoiceFilterActual";
import { useTranslation } from "../hooks/useTranslation";

function Invoices() {
  const invoicesMutation = useInvoices();
  const { t } = useTranslation();

  const [page, setPage] = useState(1);

  const invoice_filter = JSON.parse(localStorage.getItem("invoice_filter"));
  const invoice_sorting = JSON.parse(localStorage.getItem("invoice_sorting"));

  const anchorData = AnchorData();
  const current_state_id = [];
  anchorData?.pagePaid === true && current_state_id.push("paid");
  anchorData?.pageUnpaid === true && current_state_id.push("unpaid");
  anchorData?.pageUnpaidAfterDueDate === true &&
    current_state_id.push("unpaidAfterDueDate");

  const [filter, setFilter] = useState(
    anchorData
      ? {
          current_state_id: current_state_id,
        }
      : {
          ...invoice_filter,
          current_state_id:
            invoice_filter?.current_state_id || current_state_id,
        }
  );

  const [rowsSelected, setRows] = useState(10);

  const [sortTable, setSortTable] = useState({
    sort: "invoice_number",
    sortDirection: "desc",
  });

  const token = useAuthStore((state) => state.token);
  const invoices = useInvoicesStore((state) => state.invoices);

  const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
  const setPagename = useBreadcrumbsStore((state) => state.setPagename);

  useEffect(() => {
    setPagename(t("invoices.title"));
    setBreadcrumbs([]);
  }, []);

  useEffect(() => {
    if (token) {
      invoicesMutation.mutate({
        token,
        page,
        filter,
        rowsSelected,
        sortTable,
      });
    }
    localStorage.setItem("invoice_filter", JSON.stringify(filter));
    localStorage.setItem("invoice_sorting", JSON.stringify(sortTable));
  }, [token, page, filter, rowsSelected, sortTable]);

  /* Dynamická tabulka */

  const selectedColumns = useInvoicesTableStore((state) => state.selectedColumns);
  const toggleColumn = useInvoicesTableStore((state) => state.toggleColumn);
  const getAvailableColumns = useInvoicesTableStore((state) => state.getAvailableColumns);
  const awailableColumns = getAvailableColumns();

  return (
    <>
      <div className="card mt-6">
        <div className="card-header border-0 pt-6">
          <div className="card-title">
            <div className="d-flex gap-2 align-items-center mb-2">
              <FulltextFilter
                onChange={(e) =>
                  setFilter({
                    ...filter,
                    fulltext: e.target.value,
                  })
                }
                placeholder={t("invoices.searchInvoice")}
              />
              <div>
                <button
                  className="btn btn-md btn-success"
                  onClick={() =>
                    PartnerApi.invoicesExport({
                      token,
                      rowsSelected,
                      filter,
                    })
                  }
                >
                  {t("common.exportXlsx")}
                </button>
              </div>
            </div>
          </div>

          <div className="card-toolbar">
            <InvoiceFilter
              awailableColumns={awailableColumns}
              selectedColumns={selectedColumns}
              toggleColumn={toggleColumn}
              setFilter={setFilter}
              filter={filter}
            />
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="border-top border-bottom py-3">
            {t("common.totalCount")}: {invoices?.rows}
          </div>
          <InvoiceFilterActual setFilter={setFilter} filter={filter} />

          <InvoiceTable
            invoices={invoices}
            awailableColumns={awailableColumns}
            selectedColumns={selectedColumns}
            checkbox={true}
            sortTable={sortTable}
            setSortTable={setSortTable}
            token={token}
          />
        </div>
      </div>

      {invoices?.rows > 0 && (
        <>
          <Pagination
            total_pages={invoices.total_pages}
            rows_per_page={invoices.rows_per_page}
            page={page}
            setPage={setPage}
          />
          <RowSelector setRows={setRows} />
        </>
      )}
    </>
  );
}

export default Invoices;
